$(function () {
	var shareTitle = "鸡神他又来了，投票抽外设~",
    shareInfo = "参与2019完美盛典CSGO福利活动，投票即可赢取限量电竞外设！",
    shareUrl =
      "https://img.dota2.com.cn/file/a3/50/a350ed6b77ffa33b88d79ea77b62852f1573874415.jpg";
	wx.ready(function () {
        //分享给朋友
		wx.onMenuShareAppMessage({
			title: shareTitle,
			desc: shareInfo,
			link: window.location.href,
			imgUrl: shareUrl,
			trigger: function (res) {
				// 不要尝试在trigger中使用ajax异步请求修改本次分享的内容，因为客户端分享操作是一个同步操作，这时候使用ajax的回包会还没有返回
				//alert('用户点击发送给朋友');
			},
			success: function (res) {
				//
			},
			cancel: function (res) {
				//alert('已取消');
			},
			fail: function () {
			}
		});
        //分享到朋友圈
		wx.onMenuShareTimeline({
			title: shareTitle,
			link: window.location.href,
			imgUrl: shareUrl,
			trigger: function (res) {
				// 不要尝试在trigger中使用ajax异步请求修改本次分享的内容，因为客户端分享操作是一个同步操作，这时候使用ajax的回包会还没有返回
				//alert('用户点击分享到朋友圈');
			},
			success: function (res) {
				//
			},
			cancel: function (res) {
				//alert('已取消');
			},
			fail: function () {
			}
		});
    //分享到QQ
    wx.onMenuShareQQ({
        title: shareTitle, // 分享标题
        desc: shareInfo, // 分享描述
        link: location.href, // 分享链接
        imgUrl: shareUrl, // 分享图标
        success: function() {
            // 用户确认分享后执行的回调函数
        },
        cancel: function() {
            // 用户取消分享后执行的回调函数
        }
    });
	});
})
